<script>
	import PackageCard from "./PackageCard.vue";

	export default {
		components: {PackageCard},
		computed: {
			provider() {
				return window._provider
			}
		}
	}
</script>

<template>
	<div class="packages-section-body has-top-border" :class="[`card-size-${provider.products.length}`]">
		<package-card v-for="p in provider.products" :key="p.solution_id" :product="p" :provider-slug="provider.slug" />
	</div><!-- end.packages-section-body -->
</template>
